module.exports = __webpack_public_path__ + "static/media/599.702(7).2d49de0e.pdf";